import React, { Suspense } from 'react';
import '@src/i18n';

import { JetCourierLayout } from '@src/apps/JetCourierStatements/layouts/JetCourierLayout';
import { ScooberTheme } from '@src/apps/ScooberApps/components/ScooberTheme';
(window as any).usabilla_live('hide');
export const JetCourier = () => {
  return (
    <Suspense fallback={'loading....'}>
      <ScooberTheme>
        <JetCourierLayout />
      </ScooberTheme>
    </Suspense>
  );
};

export default JetCourier;
